// extracted by mini-css-extract-plugin
module.exports = {"Workspace":"Workspace_Workspace__2E7Ay","HeaderSpace":"Workspace_HeaderSpace__2mlcz","Title":"Workspace_Title__2Sx4M","PageWrapper":"Workspace_PageWrapper__3Kvqg"};